export default __webpack_public_path__ + "images/05ce86cd24913f72e337b72e1508a26e-poverty.jpg";